import { Container, Grid } from '@mui/material'
import React from 'react'
import CardAccordions from './Accordion'
// $PPF will be listed on PulseX. To buy $PPF, head over to the following link: 
const accordionList = [
    [
        '• How to buy $PPF?', // title
        '$PPF will be listed on PulseX. To buy $PPF', // details
    ],
    [
        '• How to add $PPF to your wallet?', // title
        'Head over to Metamask and click `Import tokens`. Then, copy $PPF contract and paste it in the required tab.', // details
    ],
    [
        '• How to See/Claim Reward?', // title
        'Your accumulated $PLS rewards will be delivered automatically to your wallet. You can log in to your dashboard to see the rewards.', // details
    ],
]
export const FAQs = () => {
  return (
      <Container id="faqs" maxWidth="xl" className='py-5 my-lg-5'>
          <Grid container>
              <Grid xs={12}>
                  <CardAccordions
                    accordionContent={accordionList}
                  />
              </Grid>
          </Grid>
      </Container>
  )
}
